import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { getClassSet, splitBsProps } from './utils/bootstrapUtils';
import createChainedFunction from './utils/createChainedFunction';
import CloseButton from './CloseButton';
import ModalContext from './ModalContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ModalHeader(_ref) {
  let {
    closeLabel = 'Close',
    closeButton = false,
    onHide,
    className,
    children,
    bsClass = 'modal-header',
    ...props
  } = _ref;
  const [bsProps, elementProps] = splitBsProps({
    ...props,
    bsClass
  });
  const classes = getClassSet(bsProps);
  return /*#__PURE__*/_jsx(ModalContext.Consumer, {
    children: contextValue => /*#__PURE__*/_jsxs("div", {
      ...elementProps,
      className: clsx(className, classes),
      children: [closeButton && /*#__PURE__*/_jsx(CloseButton, {
        label: closeLabel,
        onClick: createChainedFunction(contextValue && contextValue.onHide, onHide)
      }), children]
    })
  });
}

// TODO: `aria-label` should be `closeLabel`.

export default ModalHeader;